module.exports = __webpack_public_path__ + "static/media/woman-yelling-at-cat.b5a7b03f.jpg";